import { render, staticRenderFns } from "./PaymentDetail.vue?vue&type=template&id=20ad764c&scoped=true"
import script from "./PaymentDetail.vue?vue&type=script&lang=js"
export * from "./PaymentDetail.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetail.vue?vue&type=style&index=0&id=20ad764c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ad764c",
  null
  
)

export default component.exports